import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IpemarksService } from '../ipemarks.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import flatpickr from 'flatpickr';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-ipemarks-search',
  templateUrl: './ipemarks-search.component.html',
  styleUrls: ['./ipemarks-search.component.scss']
})
export class IpemarksSearchComponent implements OnInit, AfterViewInit, OnDestroy {
  IPEMARKSForm!: FormGroup;
  inputdate: any;
  buildingid: any;
  selectedTestCode: any;
  selectedSectionId: any;
  classid: any;
  testlist: any;
  filteredTestList: any;
  selectedtestname: any;
  searchCriteria: any;
  @ViewChild('fromDateInput') fromDateInput!: ElementRef<HTMLInputElement>;
  @ViewChild('toDateInput') toDateInput!: ElementRef<HTMLInputElement>;
  buildinglist: any;
  listofsection: any;
  studentlist: any;
  searchCriteriaValue: any;
  selectedStudent: any;
  filteredStudents: any[] = [];
  payload: any
  searchText: "";
  students: any;
  maxMarks: any;
  enteredMarks: number;
  sectionName: any;
  sectionId: any;
  isLoading: boolean = true;
  isFormSubmited: boolean = false;
  errorMessage: any;
  private fromPicker: any;
  private toPicker: any;
  testQuery = '';

  get canUpdateMarks(): boolean {
    return this.services.canUpdateIpeMarks();
  }

  constructor(private fb: FormBuilder, private services: IpemarksService, private dialogRef: MatDialogRef<IpemarksSearchComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private cdr: ChangeDetectorRef, private toast: ToastmessageService,private spinner: NgxSpinnerService) {

  }
  ngOnInit(): void {
    this.IPEMARKSForm = this.fb.group({
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required],
      testCode: ['', Validators.required],
      Building: ['', Validators.required],
      Section: ['', Validators.required]
    });
    this.IPEMARKSForm.patchValue({
      testCode: this.data?.testname || '',
      Building: this.data?.buliding || '',
      Section: this.data?.section || ''
    });
    this.buildingid = this.data?.buliding;
    this.selectedTestCode = this.data?.testname;
    this.selectedSectionId = this.data?.section;
    this.classid = this.data?.classid;
    this.onbuildinglist();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.initDatePickers(), 0);
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.destroyDatePickers();
  }

  private initDatePickers(): void {
    this.destroyDatePickers();
    if (this.fromDateInput?.nativeElement) {
      this.fromPicker = flatpickr(this.fromDateInput.nativeElement, {
        dateFormat: 'd-m-Y',
        allowInput: false,
        clickOpens: true,
        closeOnSelect: true,
        disableMobile: true,
        defaultDate: this.IPEMARKSForm.value.fromDate || undefined,
        appendTo: document.body,
        onReady: (_dates, _str, instance) => {
          instance.calendarContainer.classList.add('ipe-flatpickr');
        },
        onChange: (_dates, dateStr) => {
          this.IPEMARKSForm.patchValue({ fromDate: dateStr });
          if (this.toPicker) {
            this.toPicker.set('minDate', dateStr || undefined);
          }
          const toDate = this.IPEMARKSForm.value.toDate;
          if (dateStr && toDate) {
            const start = flatpickr.parseDate(dateStr, 'd-m-Y');
            const end = flatpickr.parseDate(toDate, 'd-m-Y');
            if (start && end && end < start) {
              this.toPicker?.clear();
              this.IPEMARKSForm.patchValue({ toDate: '' });
              this.clearTestSelection();
            } else {
              this.loadTestsInRange();
            }
          } else {
            this.clearTestSelection();
          }
          this.cdr.detectChanges();
          setTimeout(() => this.fromPicker?.close(), 0);
        }
      });
    }
    if (this.toDateInput?.nativeElement) {
      this.toPicker = flatpickr(this.toDateInput.nativeElement, {
        dateFormat: 'd-m-Y',
        allowInput: false,
        clickOpens: true,
        closeOnSelect: true,
        disableMobile: true,
        defaultDate: this.IPEMARKSForm.value.toDate || undefined,
        minDate: this.IPEMARKSForm.value.fromDate || undefined,
        appendTo: document.body,
        onReady: (_dates, _str, instance) => {
          instance.calendarContainer.classList.add('ipe-flatpickr');
        },
        onChange: (_dates, dateStr) => {
          this.IPEMARKSForm.patchValue({ toDate: dateStr });
          if (this.IPEMARKSForm.value.fromDate && dateStr) {
            this.loadTestsInRange();
          } else {
            this.clearTestSelection();
          }
          this.cdr.detectChanges();
          setTimeout(() => this.toPicker?.close(), 0);
        }
      });
    }
  }

  private destroyDatePickers(): void {
    if (this.fromPicker) {
      this.fromPicker.destroy();
      this.fromPicker = null;
    }
    if (this.toPicker) {
      this.toPicker.destroy();
      this.toPicker = null;
    }
  }

  openFromCalendar(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    if (!this.fromPicker) {
      this.initDatePickers();
    }
    setTimeout(() => this.fromPicker?.open(), 0);
  }

  openToCalendar(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    if (!this.toPicker) {
      this.initDatePickers();
    }
    setTimeout(() => this.toPicker?.open(), 0);
  }

  private clearTestSelection(): void {
    this.testlist = [];
    this.filteredTestList = [];
    this.selectedTestCode = '';
    this.selectedtestname = '';
    this.testQuery = '';
    this.IPEMARKSForm.patchValue({ testCode: '' });
  }

  loadTestsInRange(): void {
    const fromDate = this.IPEMARKSForm.value.fromDate;
    const toDate = this.IPEMARKSForm.value.toDate;
    if (!fromDate || !toDate) {
      return;
    }
    this.inputdate = fromDate;
    this.clearTestSelection();
    this.spinner.show();
    this.services.getTestsInBetweenDates(fromDate, toDate).subscribe({
      next: (res: any) => {
        const list = Array.isArray(res)
          ? res
          : (res?.testNames || res?.tests || res?.ipeTestNames || res?.data || []);
        this.testlist = list;
        this.filteredTestList = [...this.testlist];
        this.spinner.hide();
        if (!this.testlist.length) {
          this.toast.showWarning('No tests found for selected dates');
        }
      },
      error: () => {
        this.testlist = [];
        this.filteredTestList = [];
        this.spinner.hide();
        this.toast.showWarning('No tests found for selected dates');
      }
    });
  }
  ontestcode(e: any) {
    this.selectedTestCode = e?.target?.value
    const selectedTest = this.testlist.find((test: any) => test.testCode == this.selectedTestCode);
    if (selectedTest) {
      this.selectedtestname = this.getApiTestDisplayName(selectedTest);
      this.classid = selectedTest.classId
      this.inputdate = (selectedTest.testStartDate || selectedTest.startDate || selectedTest.fromDate ||
        selectedTest.testDate || this.IPEMARKSForm.value.fromDate || '').toString().trim();
    }
    this.selectedStudent = null;
    this.selectedStudent=[],
    this.searchCriteria=""
  }

  /** Search-by-admission dropdown: test name only, without a concatenated test date. */
  getApiTestDisplayName(test: any): string {
    if (!test) {
      return '';
    }
    const name = (test.testName || test.examName || test.name || '').toString().trim();
    const withoutDates = name
      .replace(/\s+\d{1,2}[-/.]\d{1,2}[-/.]\d{2,4}(?:\s+to\s+\d{1,2}[-/.]\d{1,2}[-/.]\d{2,4})?\s*$/i, '')
      .trim();
    return withoutDates || name;
  }

  filterTests(): void {
    const q = (this.testQuery || '').toLowerCase();
    this.filteredTestList = (this.testlist || []).filter((t: any) =>
      this.getApiTestDisplayName(t).toLowerCase().includes(q)
    );
  }

  selectTest(test: any): void {
    this.selectedTestCode = test.testCode;
    this.selectedtestname = this.getApiTestDisplayName(test);
    this.classid = test.classId;
    this.inputdate = (test.testStartDate || test.startDate || test.fromDate || test.testDate ||
      this.IPEMARKSForm.value.fromDate || '').toString().trim();
    this.IPEMARKSForm.patchValue({ testCode: test.testCode });
    this.selectedStudent = null;
    this.searchCriteria = '';
  }

  testname(e: any) {
    // kept for compatibility — tests load from start/end dates
  }
  sectionlist(e: any) {
    this.buildingid = e?.target?.value
    if (!this.buildingid || !this.classid) {
      return;
    }
    this.services.getsectionlist(this.buildingid, this.getIpeLocationParams()).subscribe((res: any) => {
      this.listofsection = res;

    })
  }
  onbuildinglist() {
    this.services.getipebuilding(this.getIpeLocationParams()).subscribe((res: any) => {
      this.buildinglist = res

    })
  }

  private getIpeLocationParams(): {
    academicId?: any;
    classId?: any;
    groupId?: any;
    streamId?: any;
    programId?: any;
  } {
    return {
      academicId: this.data?.academicId ?? this.data?.academicYearId,
      classId: this.data?.classId ?? this.classid,
      groupId: this.data?.groupId,
      streamId: this.data?.streamId,
      programId: this.data?.programId
    };
  }
  validateMarks(subject: any): void {
    if (this.isSubjectMarksReadonly(subject)) {
      return;
    }
    const input = subject.marks?.toUpperCase();
    if (input === 'A' || input === 'NC') {
      subject.marks = input; // Valid 'A' or 'NC'
      return;
    }
    this.maxMarks = subject.maxMarks || 0;
    this.enteredMarks = Number(subject.marks);
    if (this.enteredMarks > this.maxMarks) {
      subject.marks = this.maxMarks;
      alert(`Marks cannot exceed the maximum allowed marks (${this.maxMarks}).`);
      subject.marks = '';

    } else if (this.enteredMarks < 0) {
      subject.marks = 0;
      alert(`Marks cannot be negative.`);
      subject.marks = '';
    }
  }

  /** NC from API (or Max 0) → readonly in student details. */
  isSubjectMarksReadonly(subject: any): boolean {
    if (!subject) {
      return false;
    }
    if (subject.isReadonly) {
      return true;
    }
    const apiMarks = String(subject.marks ?? '').trim().toUpperCase();
    return apiMarks === 'NC' || String(subject.maxMarks) === '0';
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value + event.key; // Simulate the input value after the keypress
  
    // Regex to allow partial 'NC', full 'NC', 'A', or numbers
    const validInputPattern = /^(a|A|n|N|nc|NC|\d*)$/;
  
    // Prevent invalid characters
    if (!validInputPattern.test(currentValue)) {
      event.preventDefault();
      return;
    }
  
    // Special case: Block more than 'NC'
    const isNC = /^(n|N)(c|C)?$/;
    if (!isNC.test(currentValue) && currentValue.toUpperCase() !== 'A' && isNaN(Number(currentValue))) {
      event.preventDefault();
    }
  }
  onKeydown(event: any) {

    if (event.key === "Enter") {
      this.search(this.searchCriteria)
      console.log(event);
    }
  }
  search(searchCriteria: any) {
    if (!this.IPEMARKSForm.value.fromDate) {
      alert("Please select Start Date");
      return;
    }
    if (!this.IPEMARKSForm.value.toDate) {
      alert("Please select End Date");
      return;
    }
    if (!this.selectedTestCode) {
      alert("Please Selected the TestName");
      return;
    }
    if (!searchCriteria) {
      alert("Please enter Admission No");
      return;
    }

    this.isLoading = true;
    this.searchText = searchCriteria;
    this.errorMessage = '';
    this.selectedStudent = null;
    this.spinner.show();

    // Step 1: admission check. Step 2 (stdIpeMarks) runs only when this succeeds.
    this.services.programBasedStudentSearch(this.selectedTestCode, searchCriteria).subscribe({
      next: (checkRes: any) => {
        if (this.isApiFailure(checkRes)) {
          this.showAdmissionSearchError(
            this.getApiErrorMessage(checkRes) || 'Unable to search this admission for the selected test.'
          );
          return;
        }
        const studentMeta = this.resolveStudentMetaFromSearch(checkRes, searchCriteria);
        if (!studentMeta.admNo) {
          this.showAdmissionSearchError('No student record found for the given Admission Number.');
          return;
        }
        this.loadSingleStudentTestDetails(studentMeta);
      },
      error: (error) => {
        this.showAdmissionSearchError(
          this.getApiErrorMessage(error) || this.fallbackAdmissionSearchError(error)
        );
      }
    });
  }

  /** True when programBasedStudentSearch returned an error body (even on HTTP 200). */
  private isApiFailure(source: any): boolean {
    const body = this.getApiErrorBody(source);
    if (body == null || typeof body !== 'object' || Array.isArray(body)) {
      return false;
    }
    const description = String(body.error_description ?? body.errorDescription ?? body.errorMessage ?? '').trim();
    if (description) {
      return true;
    }
    const err = String(body.error ?? '').trim().toLowerCase();
    if (err && err !== 'null' && err !== 'undefined') {
      return true;
    }
    const status = String(body.status ?? body.success ?? '').trim().toLowerCase();
    return status === 'error' || status === 'fail' || status === 'failed' || status === 'false';
  }

  /** Pull admNo / name / section from programBasedStudentSearch (or typed admission). */
  private resolveStudentMetaFromSearch(res: any, fallbackAdmNo: any): {
    admNo: string;
    name: string;
    sectionId: any;
    sectionName: string;
  } {
    const payload = res?.data || res?.result || res;
    let row: any = null;
    if (Array.isArray(payload) && payload.length) {
      row = payload[0];
    } else if (payload?.testWiseStudents?.length) {
      row = payload.testWiseStudents[0];
    } else if (payload?.admNo || payload?.admissionNo || payload?.studentName || payload?.name) {
      row = payload;
    }
    return {
      admNo: String(row?.admNo ?? row?.admissionNo ?? fallbackAdmNo ?? '').trim(),
      name: String(row?.name ?? row?.studentName ?? row?.student_name ?? '').trim(),
      sectionId: row?.sectionId ?? row?.section_id ?? null,
      sectionName: String(row?.sectionName ?? row?.section_name ?? '').trim()
    };
  }

  private loadSingleStudentTestDetails(studentMeta: {
    admNo: string;
    name: string;
    sectionId: any;
    sectionName: string;
  }): void {
    const testDate = this.getStdIpeMarksTestDate();
    this.services.getStdIpeMarks(this.selectedTestCode, studentMeta.admNo, testDate).subscribe({
      next: (res: any) => {
        const apiError = this.getApiErrorMessage(res);
        if (apiError) {
          this.showAdmissionSearchError(apiError);
          return;
        }
        const payload = res?.headers && res?.testWiseStudents
          ? res
          : (res?.data || res?.result || res);
        if (payload && payload.headers && payload.headers.testWiseSubjects && payload.testWiseStudents?.length) {
          this.studentlist = payload;
          this.studentlist.testWiseStudents.forEach((student: any) => {
            // stdIpeMarks may return empty admNo/name — fill from step 1
            student.admNo = String(student.admNo || studentMeta.admNo || '').trim();
            student.name = String(student.name || student.studentName || studentMeta.name || '').trim();
            student.classId = student.classId ?? student.class_id ?? this.classid ?? this.data?.classId;
            student.sectionId = student.sectionId ?? studentMeta.sectionId;
            student.sectionName = String(student.sectionName || studentMeta.sectionName || '').trim();
            this.sectionName = student.sectionName;
            this.sectionId = student.sectionId;
            (student.subjects || []).forEach((subject: any) => {
              const testSubject = this.studentlist.headers.testWiseSubjects.find(
                (test: any) => test.subject === subject.subjectName
              );
              if (testSubject) {
                subject.maxMarks = testSubject.maxMarks;
              } else {
                console.warn(`No match found for subject: ${subject.subjectName}`);
              }
              const apiMarks = String(subject.marks ?? '').trim().toUpperCase();
              subject.isReadonly =
                apiMarks === 'NC' ||
                String(subject.maxMarks) === '0' ||
                String(subject.maxMarks) === 'Max : 0';
            });
          });
          this.selectedStudent = this.studentlist.testWiseStudents[0];
          this.isLoading = false;
          this.errorMessage = '';
        } else {
          this.selectedStudent = null;
          this.isLoading = false;
          this.errorMessage = "No student record found for the given Admission Number.";
        }
        this.spinner.hide();
      },
      error: (error) => {
        this.handleAdmissionSearchError(error);
      }
    });
  }

  /** testDate for stdIpeMarks — DD-MM-YYYY from selected test or Start Date */
  private getStdIpeMarksTestDate(): string {
    const selectedTest = (this.testlist || []).find((t: any) => t.testCode == this.selectedTestCode);
    const fromTest = selectedTest
      ? (selectedTest.testStartDate || selectedTest.startDate || selectedTest.fromDate || selectedTest.testDate || '')
      : '';
    return String(fromTest || this.inputdate || this.IPEMARKSForm.value.fromDate || '').trim();
  }

  private getApiErrorBody(source: any): any {
    const raw = source?.error !== undefined ? source.error : source;
    if (raw == null) {
      return source;
    }
    if (typeof raw === 'string') {
      const text = raw.trim();
      if (text.startsWith('{') || text.startsWith('[')) {
        try {
          return JSON.parse(text);
        } catch {
          return { error_description: text };
        }
      }
      return { error_description: text };
    }
    if (typeof raw === 'object') {
      return raw;
    }
    return source;
  }

  private getApiErrorMessage(source: any): string {
    const body = this.getApiErrorBody(source);
    const candidates = [
      body?.error_description,
      body?.errorDescription,
      body?.errorMessage,
      body?.message,
      body?.error
    ];
    for (const value of candidates) {
      const text = String(value ?? '').trim();
      if (!text) {
        continue;
      }
      const lower = text.toLowerCase();
      if (
        lower === 'error' ||
        lower === 'bad request' ||
        lower === 'null' ||
        lower === 'undefined' ||
        lower.startsWith('http failure response')
      ) {
        continue;
      }
      return text;
    }
    return '';
  }

  private fallbackAdmissionSearchError(error: any): string {
    const status = Number(error?.status);
    if (status === 204 || status === 404) {
      return 'No student record found for the given Admission Number.';
    }
    if (status === 400 || status === 409 || status === 422) {
      return 'Unable to search this admission for the selected test.';
    }
    return 'An unexpected error occurred. Please try again later.';
  }

  private showAdmissionSearchError(message: string): void {
    this.isLoading = false;
    this.isFormSubmited = false;
    this.selectedStudent = null;
    this.errorMessage = message;
    this.toast.showError(message);
    this.spinner.hide();
    this.cdr.detectChanges();
  }

  private handleAdmissionSearchError(error: any): void {
    this.showAdmissionSearchError(
      this.getApiErrorMessage(error) || this.fallbackAdmissionSearchError(error)
    );
  }

  studentmarkslist(): void {
    if (!this.canUpdateMarks) {
      this.toast.showError('Update permission is not enabled for this role');
      return;
    }
    this.payload = {
      ipeMarks: {
        testDate: String(this.IPEMARKSForm.value.fromDate || this.inputdate || ''),
        testCode: String(this.selectedTestCode || ''),
        sectionId: String(this.sectionId || this.selectedSectionId || ''),
        students: [
          {
            admNo: String(this.selectedStudent.admNo ?? ''),
            classId: Number(this.selectedStudent.classId ?? this.classid ?? this.data?.classId) || 0,
            subjects: this.selectedStudent.subjects.map((subject: any) => ({
              subject: String(subject.subjectName ?? subject.subject ?? ''),
              marks: this.markPayloadValue(subject.marks)
            })),
          },
        ],
      },
    };
    console.log('Payload:', this.payload);
    if (confirm('Do you want to save IPE markes details?')) {
      this.spinner.show();
      this.services.saveStudentMarks(this.payload).subscribe({
        next: (res: any) => {
          if (res?.toString?.().includes('not')) {
            this.toast.showWarning(res.toString());
            this.isFormSubmited = false;
            this.spinner.hide();
            return;
          }
          this.toast.showSuccess(res?.message || 'IPE marks Saved Successfully.');
          this.selectedStudent = null;
          this.searchCriteria = '';
          this.isFormSubmited = true;
          this.spinner.hide();
          // Close dialog → parent will call testDetails API
          this.dialogRef.close({
            saved: true,
            selectedTestCode: this.selectedTestCode,
            selectedSectionId: this.sectionId || this.selectedSectionId,
            testdate: this.IPEMARKSForm.value.fromDate || this.inputdate
          });
        },
        error: (error) => {
          console.log(error);
          this.isFormSubmited = false;
          this.spinner.hide();
        }
      });
    }
  }

  private markPayloadValue(marks: any): string {
    if (marks === null || marks === undefined || marks === '') {
      return '';
    }
    const raw = String(marks).trim();
    const upper = raw.toUpperCase();
    if (upper === 'NC' || upper === 'A') {
      return upper;
    }
    return raw;
  }

  close() {
    this.dialogRef.close();
  }
}
